import { render, staticRenderFns } from "./SearchRouterLink.vue?vue&type=template&id=4c976897"
import script from "./SearchRouterLink.vue?vue&type=script&lang=js"
export * from "./SearchRouterLink.vue?vue&type=script&lang=js"
import style0 from "./SearchRouterLink.vue?vue&type=style&index=0&id=4c976897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports